import { generateQueryString } from '../../../common/base/report/report-util';

export const queryStringCalc = ({
  reportConfig,
  criteria,
  criteriaStats,
  token,
  devSetting,
}) => {
  const params = [];
  const stats = criteriaStats || {};

  if (reportConfig) {
    if (reportConfig.filters.resaleYear) {
      if (criteria.resaleYear) {
        params.push(`resaleYear=${criteria.resaleYear}`);
      }
    }
    if (reportConfig.filters.printDetails) {
      params.push(`printDetails=${criteria.printDetails}`);
    }
    if (reportConfig.filters.printOrder) {
      params.push(`printOrder=${criteria.printOrder}`);
    }
    if (reportConfig.filters.sortOrder) {
      params.push(`sortOrder=${criteria.sortOrder}`);
    }
    if (reportConfig.filters.sortBy) {
      params.push(`sortOrder=${criteria.sortOrder}`);
    }
    if (reportConfig.filters.taxStatusCodes) {
      params.push(`taxStatusList=${(criteria.taxStatusList || []).join(',')}`);
      params.push(`allTaxStatus=${!!stats.allTaxStatus}`);
    }
  }

  if (token) {
    params.push(`token=${token}`);
  }

  /* For testcafe */
  if (devSetting && devSetting.isTestEnvironment) {
    params.push('isTestCafe=1');
  }

  return generateQueryString(params);
};

export const resaleReportList = () => {
  const item = [{
    id: 1,
    description: 'Resale List',
    config: {
      route: 'juneResale/june-resale',
      filters: {
        resaleYear: true,
        printDetails: true,
        printOrder: true,
        sortOrder: false,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 11,
    description: 'Resale List by Status code',
    config: {
      route: 'juneResale/june-resale-by-statuscode',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: true,
        sortOrder: false,
        sortBy: false,
        taxStatusCodes: true,
      },
    },
  },
  {
    id: 2,
    description: 'Resale Notification Letter',
    config: {
      route: 'juneResale/resale-notification-letter',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: true,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 10,
    description: 'Excess Resale Letter',
    config: {
      route: 'juneResale/resale-excess-letter',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: true,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 3,
    description: 'Sheriff\'s Notice',
    config: {
      route: 'juneResale/sheriff-notice',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: true,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 4,
    description: 'Public Resale List',
    config: {
      route: 'juneResale/public-resale-list',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: true,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 5,
    description: 'Certified Mailers',
    config: {
      route: 'juneResale/certified-mailers',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: false,
        sortBy: true,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 8,
    description: 'Bidder Registration List',
    config: {
      route: 'juneResale/bidder-registration-list',
      filters: {
        resaleYear: false,
        printDetails: false,
        printOrder: false,
        sortOrder: false,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 6,
    description: 'County Owned Report',
    config: {
      route: 'juneResale/county-owned-report',
      filters: {
        resaleYear: true,
        printDetails: true,
        printOrder: true,
        sortOrder: false,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 9,
    description: 'Bid Awards Slips',
    config: {
      route: 'juneResale/bid-award-slips-report',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: false,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  },
  {
    id: 7,
    description: 'Resale Breakdown',
    config: {
      route: 'juneResale/resale-breakdown',
      filters: {
        resaleYear: true,
        printDetails: false,
        printOrder: false,
        sortOrder: true,
        sortBy: false,
        taxStatusCodes: false,
      },
    },
  }];
  return item;
};

export default {
  queryStringCalc,
};
